// src/components/HomeModal/HomeModal.js

import React from 'react';
import ReactDOM from 'react-dom';
import './HomeModal.css';
import cursorDefault from '../../assets/cursors/cursor-default.png';
import cursorPointer from '../../assets/cursors/cursor-pointer.png';

const HomeModal = ({ onYes, onNo }) => {
  const modalCursorDefault = `url(${cursorDefault}) 2 2, default`;
  const modalCursorPointer = `url(${cursorPointer}) 6 2, pointer`;

  return ReactDOM.createPortal(
    <div
      className="home-modal-overlay"
      style={{ cursor: modalCursorDefault }}
    >
      <div
        className="home-base-modal"
        style={{ cursor: modalCursorDefault }}
      >
        <div
          className="home-modal-content"
          style={{ cursor: modalCursorDefault }}
        >
          <p>Are you sure you want to exit?</p>

          <button
            className="home-yes-button"
            onClick={onYes}
            style={{ cursor: modalCursorPointer }}
          >
            Yes
          </button>

          <button
            className="home-no-button"
            onClick={onNo}
            style={{ cursor: modalCursorPointer }}
          >
            No
          </button>

          <button
            className="home-close-modal-btn"
            onClick={onNo}
            aria-label="Close Home Modal"
            style={{ cursor: modalCursorPointer }}
          >
            ×
          </button>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default HomeModal;